import { useContext, useEffect } from "react";
import { SeoContext } from "./SeoContext";

/**
 * Mounts one JSON-LD <script> per instance, keyed by `id`, so a single page
 * can combine several schema.org types (Service + BreadcrumbList + FAQPage...)
 * by rendering multiple <StructuredData /> instances. Cleans up its own
 * script tag on unmount/route change.
 */
export default function StructuredData({ id, data }) {
  const collector = useContext(SeoContext);
  if (collector && id && data) collector.schemas.set(id, { "@context": "https://schema.org", ...data });
  useEffect(() => {
    if (!id || !data) return undefined;
    const scriptId = `ld-${id}`;
    let script = document.getElementById(scriptId);
    if (!script) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = scriptId;
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify({ "@context": "https://schema.org", ...data });

    return () => {
      document.getElementById(scriptId)?.remove();
    };
  }, [id, data]);

  return null;
}
